const Validations = Object.freeze({
  InvalidEmail: 'Invalid email',
  MinLengthPassword: 'The password should be 6 characters minimum',
});

export default Validations;
